import React, { Fragment, useState, useEffect } from 'react';
import {
    Button,
    Card,
    CardBody,
    Row,
    CardImg,
    Modal,
    ModalHeader,
    ModalBody,
} from 'reactstrap';
import { faTrashAlt, faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Switch from 'rc-switch';
import 'rc-switch/assets/index.css';
import Phone_New_Logo from '../../../../../../../assets/phone_new_logo.png';
import PhoneLogo from '../../../../../../../assets/phone_icon.png';
import { Colxx } from '../../../../../../../components/common/CustomBootstrap';
import { AxiosAPI, getGroupID } from '../../../../../../../helpers/AxiosAPI';
import {
    putAPI_Update_OnOff,
    dAPI_Delete_Ingetration,
    API_Phone_Suite_Interation_Group,
} from '../../../../../../../constants/APIs';
import { NavLink } from 'react-router-dom';
import PhoneSuiteIntegrationList from '../../../../integration/components/PhoneSuite/PhoneSuiteIntegrationList';

export default function PhoneSuiteIntegrationThumb({
    integration,
    allProperties,
    LoadIntegrations,
    imageDomain,
    isSelected = false,
    onSelect,
    onDelete,
}) {
    const [deleteVisible, setDeleteVisible] = useState(false);
    const [formatedProperties, setFormatedProperties] = useState('');
    const [moreProperties, setMoreProperties] = useState('');
    const [isEditing, setIsEditing] = useState(false);
    const [checkedPrimarySmall, setCheckedPrimarySmall] = useState(
        !integration.disabled
    );
    useEffect(() => {
        const result =
            integration.properties != null
                ? integration.properties.map((id) => {
                    return allProperties.find((elem) => elem.id === id);
                })
                : [];
        if (result.length > 2) {
            const filterResults = result.slice(0, 2);
            setFormatedProperties(filterResults.map((elem) => elem?.name).join(', '));
            setMoreProperties(
                'and ' + (result.length - filterResults.length) + ' more'
            );
        } else {
            const filterResults = result.filter((elem) => elem !== undefined);
            setFormatedProperties(filterResults.map((elem) => elem?.name).join(', '));
        }
    }, [integration, allProperties]);
    const toggle = () => {
        setDeleteVisible(!deleteVisible);
    };
    const handleDelete = () => {
        AxiosAPI({
            method: 'delete',
            url: `${dAPI_Delete_Ingetration}/${integration.id
                }/?group_id=${getGroupID()}`,
        }).then((res) => {
            let updateRequest = {
                updater: 'dashboard',
            };
            AxiosAPI({
                method: 'delete',
                url: `${API_Phone_Suite_Interation_Group}/${integration.id}`,
                data: updateRequest,
            })
                .then((result) => {
                    toggle();
                    LoadIntegrations();
                })
                .catch((err) => {
                    console.log('err', err);
                });
        });
    };
    const handleOnOff = (onoff) => {
        AxiosAPI({
            method: 'put',
            url: `${putAPI_Update_OnOff}/${integration.id}/?group_id=${getGroupID()}`,
            data: { disabled: onoff },
        }).then((res) => { });
    };
    const handleSwitchChange = (value) => {
        //console.log(value)
        setCheckedPrimarySmall(value);
        handleOnOff(!value);
    };
    // console.log(2345, imageDomain)
    const generateDeleteButton = () => {
        return (
            <Row>
                <Colxx xs="12" sm="12" md="12" lg="8" className="mb-4">
                    <Row>
                        <Colxx xs="12" sm="3" className="mb-1">
                            <Modal isOpen={deleteVisible} toggle={toggle}>
                                <ModalHeader toggle={toggle}>
                                    <span role="img" aria-label="warning">
                                        ⚠️
                                    </span>
                                    This action will permanently remove the integration. Are you
                                    sure you want to delete the integration?
                                </ModalHeader>
                                <ModalBody className="d-flex justify-content-space-between">
                                    <Button
                                        className="ml-2"
                                        color="dark"
                                        outline
                                        size="xs"
                                        onClick={toggle}
                                    >
                                        Go Back
                                    </Button>
                                    <Button
                                        color="danger"
                                        onClick={() => handleDelete()}
                                        size="xs"
                                    >
                                        Confirm
                                    </Button>
                                </ModalBody>
                            </Modal>
                        </Colxx>
                    </Row>
                </Colxx>
            </Row>
        );
    };
    return (
        <Fragment>
            {integration ? (
                <Colxx md="6" sm="6" lg="3" xxs="12" className="mb-3">
                    <Card className={`d-flex flex-row ${isSelected ? 'communication-channel-card-selected' : ''}`} style={{ height: '215px', position: 'relative' }}>
                        <div>
                            <h3 className="integrationChannel">
                                <img
                                    src={PhoneLogo}
                                    alt="Logo"
                                    style={{ maxWidth: '30px' }}
                                />
                            </h3>
                            {/* <a href="#/" className="integrationremove" onClick={toggle}>
              {' '}
              <h3 className="iconsminds-remove" />{' '}
            </a> */}
                            <Switch
                                className="agentswitch  custom-switch-primary custom-switch-small integrationremove"
                                checked={checkedPrimarySmall}
                                onChange={(primary) => handleSwitchChange(primary)}
                            />
                        </div>
                        {(typeof onSelect === 'function' || (isSelected && typeof onDelete === 'function')) && (
                            <div className="communication-channel-select-control">
                                {typeof onSelect === 'function' && (
                                    <button
                                        type="button"
                                        className="communication-channel-select-circle-btn"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            onSelect();
                                        }}
                                    >
                                        <div
                                            className={`communication-channel-select-circle ${isSelected ? 'selected' : ''
                                                }`}
                                        />
                                    </button>
                                )}
                                {isSelected && typeof onDelete === 'function' && (
                                    <button
                                        type="button"
                                        className="communication-channel-select-delete-btn"
                                        style={{ color: "red" }}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            onDelete();
                                        }}
                                    >
                                        <FontAwesomeIcon icon={faTimes} />
                                    </button>
                                )}
                            </div>
                        )}
                        <CardBody>
                            <Row>
                                <Colxx xxs="12" className="mb-3">
                                    <NavLink
                                        to={"#"
                                            // pathname:
                                            //     '/app/pages/phone-suite-detail/' + integration.id,
                                        }
                                        key={integration.id}
                                    >
                                        <div className="text-center mt-3">
                                            <CardImg
                                                top
                                                src={
                                                    `${imageDomain}/images/664a7811-8899-4255-8fe8-a12a6bd8b500.png`
                                                }
                                                alt="Card image cap"
                                                className="img-thumbnail border-0 rounded-circle list-thumbnail"
                                                style={{ width: '4rem', height: '70px' }}
                                            />
                                            <div className="mb-1">{integration.name}</div>
                                            <div className="mb-2">
                                                <b>{formatedProperties} </b>
                                                <b>{moreProperties}</b>
                                            </div>
                                            {/* <Button
                        size="xs"
                        color="success"
                        outline
                        style={{ marginTop: '20px', display: 'inline-block' }}
                        onClick={() => setIsEditing(!isEditing)}
                      >
                        Edit
                      </Button> */}
                                        </div>
                                    </NavLink>
                                </Colxx>
                            </Row>
                        </CardBody>
                        <div className="integrationdelete">
                            <FontAwesomeIcon
                                icon={faTrashAlt}
                                style={{ color: 'var(--theme-color-1)' }}
                                cursor="pointer"
                                onClick={toggle}
                            />
                        </div>
                    </Card>
                </Colxx>
            ) : null}
            {isEditing ? (
                <Row>
                    <Colxx xxs="12">
                        <Row>
                            <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                            <Colxx md="4" sm="4" lg="4" xxs="12">
                                <PhoneSuiteIntegrationList
                                    visible={isEditing}
                                    toggle={() => {
                                        setIsEditing(!isEditing);
                                    }}
                                    id={integration.id}
                                />
                            </Colxx>
                            <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                        </Row>
                    </Colxx>
                </Row>
            ) : null}
            {generateDeleteButton()}
        </Fragment>
    );
}
